import SectionIntro from '../../../screens/animations/sectionIntro';
import TargetSection from '../../../screens/animations/targetSection';
import Checkout from '../../../screens/checkout';
import Checkout119Test from '../../../screens/checkout119Test';
import JointPremiumCheckout from '../../../screens/jointPremiumCheckout';
import JointPremiumCheckout2 from '../../../screens/jointPremiumCheckout2';

export const CHECKOUT_SCREENS = [
    {
        key: 'target section',
        trackingName: 'target section',
        screenName: 'target section',
        component: <TargetSection />
    },
    {
        key: 'target section intro',
        screenName: 'target section intro',
        component: (
            <SectionIntro
                sectionKey={'checkout'}
                subtitle={'Next, you\'ll make a commitment to yourself by activating your free 15-day trial. If at any point you decide it\'s not for you, you can cancel anytime.'}
            />
        )
    },
    {
        key: 'checkout',
        trackingName: 'checkout - your recommendation',
        screenName: 'checkout',
        component: (
            <Checkout />
        )
    }
];

export const CHECKOUT_SCREENS_V2 = [
    {
        key: 'target section',
        trackingName: 'target section',
        screenName: 'target section',
        component: <TargetSection />
    },
    {
        key: 'target section intro',
        screenName: 'target section intro',
        component: (
            <SectionIntro
                sectionKey={'checkout'}
                subtitle={'Next, you\'ll make a commitment to yourself by activating your free 15-day trial. If at any point you decide it\'s not for you, you can cancel anytime.'}
            />
        )
    },
    {
        key: 'checkout',
        trackingName: 'checkout - your recommendation',
        screenName: 'checkout',
        component: (
            <Checkout119Test />
        )
    }
];

export const CHECKOUT_SCREENS_V3 = [
    {
        key: 'target section',
        trackingName: 'target section',
        screenName: 'target section',
        component: <TargetSection />
    },
    {
        key: 'target section intro',
        screenName: 'target section intro',
        component: (
            <SectionIntro
                sectionKey={'checkout'}
                subtitle={'Next, you\'ll make a commitment to yourself by activating your free 15-day trial. If at any point you decide it\'s not for you, you can cancel anytime.'}
            />
        )
    },
    {
        key: 'checkout',
        trackingName: 'checkout - your recommendation',
        screenName: 'checkout',
        component: (
            <JointPremiumCheckout />
        )
    }
];

export const CHECKOUT_SCREENS_V4 = [
    {
        key: 'target section',
        trackingName: 'target section',
        screenName: 'target section',
        component: <TargetSection />
    },
    {
        key: 'target section intro',
        screenName: 'target section intro',
        component: (
            <SectionIntro
                sectionKey={'checkout'}
                subtitle={'Next, you\'ll make a commitment to yourself by activating your free 15-day trial. If at any point you decide it\'s not for you, you can cancel anytime.'}
            />
        )
    },
    {
        key: 'checkout',
        trackingName: 'checkout - your recommendation',
        screenName: 'checkout',
        component: (
            <JointPremiumCheckout2 />
        )
    }
];
